module.exports = function getResource(label) {
    const resources = {
        itemSubErrorModalTitle: 'Substitute Items Removed',
        gotIt: 'Got It'
    };
    return resources[label];
};
